import { useState } from "react";
import { InvoiceArchive } from "./InvoiceArchive";
import { PaidInvoicesDashboard } from "./PaidInvoicesDashboard";

type ArchiveTab = "documents" | "paid";

const STORAGE_KEY = "archive-active-tab";

function readStoredTab(): ArchiveTab {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (value === "documents" || value === "paid") return value;
  } catch {
    /* ignore */
  }
  return "documents";
}

export function ArchiveCenter() {
  const [tab, setTab] = useState<ArchiveTab>(() => readStoredTab());

  const select = (next: ArchiveTab) => {
    setTab(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      /* ignore */
    }
  };

  return (
    <div className="flex w-full flex-col gap-4 px-4 py-6 md:px-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Archive</h1>
          <p className="text-sm text-gray-500">
            Invoice documents and settled invoice reporting
          </p>
        </div>
        <div
          role="tablist"
          aria-label="Archive sections"
          className="inline-flex rounded-lg border border-slate-200 bg-slate-100 p-1"
        >
          {(
            [
              ["documents", "Documents"],
              ["paid", "Paid invoices"],
            ] as const
          ).map(([id, label]) => (
            <button
              key={id}
              type="button"
              role="tab"
              aria-selected={tab === id}
              onClick={() => select(id)}
              className={`rounded-md px-4 py-1.5 text-sm font-medium transition-colors ${
                tab === id
                  ? "bg-white text-slate-900 shadow-sm"
                  : "text-slate-500 hover:text-slate-700"
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      {tab === "documents" ? <InvoiceArchive /> : <PaidInvoicesDashboard />}
    </div>
  );
}

export default ArchiveCenter;
